import React, { Fragment, useEffect, useState, useRef } from "react";
import { getdata, updateApp } from "./store";
import { useDispatch } from "react-redux";
import { Button, Input, Label, Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import Swal from "sweetalert2";
import Switch from "react-switch";
import { LuApple } from "react-icons/lu";
import { IoIosTimer } from "react-icons/io";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import { FaGreaterThan } from "react-icons/fa";
import { getuserdata } from "./../AppUpdate/store/index";
import { ComponentLoader } from '../common/Loader';

const AppUpdate = () => {
  const dispatch = useDispatch();
  const [appData, setAppData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [totaliOS, setTotaliOS] = useState(0);
  const [totalAndroid, setTotalAndroid] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    // Calculate and set total users
    setTotalUsers(totaliOS + totalAndroid);
  }, [totaliOS, totalAndroid]);

  const iosPercentage = ((totaliOS / totalUsers) * 100).toFixed(2);
  const androidPercentage = ((totalAndroid / totalUsers) * 100).toFixed(2);

  const dataFetchedRef = useRef(false);

  const fetchData = async () => {
    try {
      const cachedData = sessionStorage.getItem('APP_UPDATE_CACHE');
      let cacheExists = false;

      if (cachedData) {
        const data = JSON.parse(cachedData);
        if (data === 'PENDING') {
        
          return;
        }

        if (data && typeof data === 'object') {
          const cacheTimestamp = data.cacheTimestamp || 0;
          const threeMinutes = 3 * 60 * 1000;
          const isExpired = Date.now() - cacheTimestamp > threeMinutes;

          if (!isExpired) {
           
            setAppData(data.appData);
            setTotaliOS(data.totaliOS);
            setTotalAndroid(data.totalAndroid);
            setTotalUsers(data.totaliOS + data.totalAndroid);
            setIsLoading(false);
            return;
          } else {
           
            setAppData(data.appData);
            setTotaliOS(data.totaliOS);
            setTotalAndroid(data.totalAndroid);
            setTotalUsers(data.totaliOS + data.totalAndroid);
            setIsLoading(false);
            cacheExists = true;
          }
        }
      }

      if (!cacheExists) {
        setIsLoading(true);
      }

      sessionStorage.setItem('APP_UPDATE_CACHE', JSON.stringify('PENDING'));

      // Fetch User Data and App Data in parallel
      const [userResponse, appResponse] = await Promise.all([
        dispatch(getuserdata()),
        dispatch(getdata())
      ]);

      let newTotaliOS = totaliOS;
      let newTotalAndroid = totalAndroid;

      if (userResponse.payload) {
        const deviceStats = userResponse.payload.deviceStatistics || {};
        newTotaliOS = deviceStats.iOS || 0;
        newTotalAndroid = deviceStats.Android || 0;
        setTotaliOS(newTotaliOS);
        setTotalAndroid(newTotalAndroid);
        setTotalUsers(newTotaliOS + newTotalAndroid);
      }

      if (appResponse.payload && appResponse.payload.data) {
        setAppData(appResponse.payload.data);
        sessionStorage.setItem('APP_UPDATE_CACHE', JSON.stringify({
          appData: appResponse.payload.data,
          totaliOS: newTotaliOS,
          totalAndroid: newTotalAndroid,
          cacheTimestamp: Date.now()
        }));
      }
    } catch (error) {
      console.error("Error fetching app update data:", error);
      sessionStorage.removeItem('APP_UPDATE_CACHE');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!dataFetchedRef.current) {
      dataFetchedRef.current = true;
      fetchData();
    }
  }, [dispatch]);

  const openModal = (item) => {
    setSelectedData({ ...item }); // Create a new copy to avoid direct state mutation
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    // Update the main app data state
    setAppData((prev) =>
      prev.map((item) => (item.id === selectedData.id ? { ...selectedData } : item))
    );
    // Dispatch the update action
    dispatch(updateApp(selectedData)).then((response) => {
      if (response.payload.message === "success") {
        Swal.fire({
          title: "Updated Successfully!",
          icon: "success",
          confirmButtonText: "OK",
        })
      }
      dispatch(getdata()).then((response) => {
        setAppData(response.payload.data);
      });
    });
    closeModal();
  };

  const renderMobileIcon = (mobile) => {
    if (mobile === "iOS") {
      return <i className="fab fa-apple" style={{ marginRight: "8px" }}></i>;
    } else if (mobile === "Android") {
      return <i className="fab fa-android" style={{ marginRight: "8px" }}></i>;
    }
    return null;
  };

  return (
    <div className='container_alluser'>
      <div className="appupdate_contant">
        <h3 className="appudate_header">App Version</h3>
      </div>

      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
          <ComponentLoader color="#4f46e5" size="40px" />
        </div>
      ) : (
        <>
          <div className="mobile_container">
            <div className="mobile_content">
              {appData
                .filter((data) => data.mobile === "iOS")
                .map((data) => (
                  <div className="ios_container" style={{ borderTop: "5px solid #21b4f7", borderBottom: "1px solid #0099ff", borderLeft: "1px solid #0099ff", borderRight: "1px solid #0099ff" }}>
                    <div className="mobile_group">
                      <div className="icon_title"><LuApple className="icon" />
                        <div className="ios_title"> <h3>iOS</h3>
                          <h5>{data.title}</h5></div>
                      </div>

                    </div>
                    <div className="mobile_group appflex">
                      <div className="appversion">
                        <div className="appversion_text">
                          <label>App version</label>
                          <p>v{data.appVersion}</p>
                        </div>
                      </div>
                      <div className="appremainder">
                        <div className="appversion_text">
                          <label>Remainder version</label>
                          <p>v{data.remainderVersion}</p>
                        </div>
                      </div>
                    </div>
                    <div style={{ margin: "0 auto", width: "92%" }}>
                      <h3 className="version_title">Enhancement</h3>
                      <div className="history_container">
                        {data.enhancement.map((details, idx) => (
                          <div key={idx} className="details">
                            <div className="release_destail"><FaGreaterThan className="releaseicon" /> {details}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="button_container">
                      <button
                        className="updateversion"
                        onClick={() => openModal(appData.find((data) => data.mobile === "iOS"))}
                      >
                        Update version
                      </button>
                    </div>
                  </div>
                ))}

              {/* ----andriod---- */}
              {appData
                .filter((data) => data.mobile === "Android") // Filter only iOS data
                .map((data) => (
                  <div className="ios_container" style={{ borderTop: "5px solid #0eb561", borderBottom: "1px solid #0eb561", borderLeft: "1px solid #0eb561", borderRight: "1px solid #0eb561" }}>
                    <div className="mobile_group">
                      <div className="icon_title"><MdOutlinePhoneAndroid className="androidicon" />
                        <div className="ios_title"> <h3>Android</h3>
                          <h5>{data.title}</h5></div>
                      </div>

                    </div>
                    <div className="mobile_group appflex">
                      <div className="appversion">
                        <div className="appversion_text">
                          <label>App version</label>
                          <p>v{data.appVersion}</p>
                        </div>
                      </div>
                      <div className="appremainder">
                        <div className="appversion_text">
                          <label>Remainder version</label>
                          <p>v{data.remainderVersion}</p>
                        </div>
                      </div>
                    </div>
                    <div style={{ margin: "0 auto", width: "92%" }}>
                      <h3 className="version_title">Enhancement</h3>
                      <div className="history_container">
                        {data.enhancement.map((details, idx) => (
                          <div key={idx} className="details">
                            <div className="release_destail"><FaGreaterThan className="releaseicon" /> {details}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="button_container">
                      <button
                        className="updateversion"
                        onClick={() => openModal(appData.find((data) => data.mobile === "Android"))}
                      >
                        Update version
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>


          <div className="activities_container">
            <section className="version_timeline">
              <div className="version_container">
                <h3>version timeline</h3>
                <label> release history across platforms</label>

                <div>
                  {appData
                    .filter((data) => data.mobile === "iOS")
                    .map((data) => (

                      <div className="version_ios">
                        <LuApple className="version_icon" />
                        <h4>Current - iOS v{data.appVersion}</h4>
                      </div>
                    ))}
                  {appData
                    .filter((data) => data.mobile === "Android")
                    .map((data) => (


                      <div className="version_android " >
                        <MdOutlinePhoneAndroid className="version_icon" />
                        <h4>Current - Android v{data.appVersion}</h4>
                      </div>
                    ))}
                </div>
              </div>
            </section>



            <section className="version_timeline">
              <div className="version_container">

                <h3>User Adoption</h3>
                <label> version distribution by platforms</label>

                <div className="user_adoption_content">
                  <div className="user_adoption">
                    <div className="user_adoption_container">
                      <h4>iOS v1.0</h4>
                      <p>{iosPercentage}%</p>
                    </div>

                    <div className="progresss_container" style={{
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid grey"
                    }} >
                      <div
                        className="progress_bar"
                        style={{
                          width: `${iosPercentage}%`,
                          height: "25px",
                          backgroundColor: "#21b4f7",
                          borderRadius: "4px",
                          transition: "width 0.3s ease",

                        }}
                      />
                    </div>
                  </div>
                  <div className="user_adoption">
                    <div className="user_adoption_container">

                      <h4>Android v1.0</h4>
                      <p>{androidPercentage}%</p>
                    </div>
                    <div className="progresss_container" style={{
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid grey"
                    }} >
                      <div
                        className="progress_bar"
                        style={{
                          width: `${androidPercentage}%`,
                          height: "25px",
                          backgroundColor: "#f72168",
                          borderRadius: "4px",
                          transition: "width 0.3s ease",

                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="version_timeline">
              <div className="version_container">
                <h3>Recent Activity</h3>
                <label> Latest version </label>
                <div className="activity_container">
                  <div className="activity_icon">
                    <LuApple className="history_ios_icon histroy_apple" />
                  </div>
                  <div className="activity_text">
                    <h5>iOS security updates</h5>
                    <p>Released v1.0 </p>
                  </div>
                </div>
                <div className="activity_container">
                  <div className="activity_icon">
                    <MdOutlinePhoneAndroid className="history_android_icon " />

                  </div>
                  <div className="activity_text">
                    <h5>Andriod security updates</h5>
                    <p>Released v1.0 </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}



      {isModalOpen && selectedData && (
        <Modal isOpen={isModalOpen} toggle={closeModal} size="l">
          <ModalHeader toggle={closeModal}>
            <h3 className="appupdate_label">App Update </h3>
          </ModalHeader>
          <ModalBody>
            <Row style={{ marginBottom: "10px" }}>
              <Col>
                <Label className="appupdate_label">App Version:</Label>
                <Input
                  type="text"
                  name="appVersion"
                  value={selectedData?.appVersion || ""}
                  onChange={handleChange}
                  style={{ color: "black" }}
                  className="appudate_form"
                /></Col>
              <Col>
                <Label className="appupdate_label">Remainder Version:</Label>
                <Input
                  type="text"
                  name="remainderVersion"
                  value={selectedData?.remainderVersion || ""}
                  onChange={handleChange}
                  style={{ color: "black" }}
                  className="appudate_form"
                /></Col>
            </Row>




            <Label className="appupdate_label">Enhancements:</Label>
            <Input
              type="textarea"
              name="enhancement"
              value={selectedData?.enhancement?.join("\n") || ""}
              onChange={(e) => setSelectedData((prev) => ({
                ...prev,
                enhancement: e.target.value.split("\n"), // Convert back to an array
              }))}
              style={{ color: "black", height: "150px" }}
            />
            <br />
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Label className="appupdate_label">Force:</Label>
              <Switch
                checked={selectedData?.force || false}
                onChange={(checked) => {
                  setSelectedData((prev) => ({
                    ...prev,
                    force: checked, // Update the force value in selectedData
                  }));
                }}
              />
            </div>
            <br />
            <div className="div-btn">
              <button className="btn-edit" onClick={handleSave}>Save</button>&nbsp;
              <button className="btn-cancel" onClick={closeModal}>Cancel</button>
            </div>
          </ModalBody>
        </Modal>
      )}
    </div>

  );
};

export default AppUpdate;


{/* <div className="card-container">
{appData.map((item) => (
  <div key={item.id} className="app-card">
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <h2 style={{ margin: 0 }}>
        {renderMobileIcon(item.mobile)}
        {item.mobile}
      </h2>
      <Button className="btn-edit" onClick={() => openModal(item)}>
        <i className="fas fa-pen"></i>
      </Button>
    </div>
    <p>
      <strong>Title:</strong> {item.title}
    </p>
    <p>
      <strong>App Version:</strong> {item.appVersion}
    </p>
    <p>
      <strong>Remainder Version:</strong> {item.remainderVersion}
    </p>
    <div style={{ overflowWrap: "anywhere" }}>
      <strong>Enhancement:</strong>
      <br />
      {item.enhancement.map((enh, index) => (
        <p key={index}>{enh}</p>
      ))}
    </div>
  </div>
))}
</div> */}